import { useCallback, useMemo } from 'react';
import api from '../api/Client';

export const useApi = () => {
    const request = useCallback(async (method, url, data = null, config = {}) => {
        try {
            let response;
            if (['get', 'delete'].includes(method.toLowerCase())) {
                response = await api[method](url, config);
            } else {
                response = await api[method](url, data, config);
            }
            return response.data;
        } catch (err) {
            const error = {
                message: err.message,
                response: {
                    status: err.response?.status,
                    data: err.response?.data || { detail: 'Network Error' },
                },
            };
            // Handle 401/403 errors globally (skip if already on login page or calling login API)
            if ([401, 403].includes(error.response?.status) && !url.includes('login') && window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
            throw error;
        }
    }, []);

    return useMemo(() => ({
        get: (url, config) => request('get', url, null, config),
        post: (url, data, config) => request('post', url, data, config),
        put: (url, data, config) => request('put', url, data, config),
        patch: (url, data, config) => request('patch', url, data, config),
        delete: (url, config) => request('delete', url, null, config),
        del: (url, config) => request('delete', url, null, config),
    }), [request]);
};